import { Users } from "lucide-react";
import { ManualeLayout, Scheda, P, Steps, Bullets, Callout, FAQ } from "@/pages/manuali/ManualeLayout";

const A = "#1B2380";
const SEZIONI = [
  { id: "intro", titolo: "A cosa serve" },
  { id: "ruoli", titolo: "Ruoli e accessi" },
  { id: "area", titolo: "Area del dipendente" },
  { id: "assenze", titolo: "Richieste assenze" },
  { id: "note", titolo: "Note spese e rimborsi" },
  { id: "cruscotto", titolo: "Cruscotto HR" },
  { id: "faq", titolo: "FAQ e avvertenze" },
];

export default function ManualePersonale() {
  return (
    <ManualeLayout titolo="Gestione del Personale" sottotitolo="Portale HR: fascicoli, assenze, note spese e cruscotto" icona={Users} accent={A} sezioni={SEZIONI}>
      <Scheda id="intro" n="1" titolo="A cosa serve" accent={A}>
        <P>È il <b>portale HR</b> dell'agenzia. Ogni dipendente ha una <b>propria area riservata</b> dove consulta i suoi documenti e invia richieste; <b>Admin e delegati</b> gestiscono anagrafiche, approvano assenze e note spese e consultano il cruscotto.</P>
      </Scheda>

      <Scheda id="ruoli" n="2" titolo="Ruoli e accessi" accent={A}>
        <Bullets items={[
          "Admin: accesso completo a tutte le sezioni.",
          "Delegato (flag 'Delegato' sulla scheda persona): gestisce e approva come un manager.",
          "Dipendente: vede solo 'La mia area'.",
        ]} />
        <P><b>Creare l'accesso di un dipendente</b> (Admin/Delegato): tab <b>Soci/Collaboratori</b> → icona 🔑 sulla riga → inserisci email e password (min. 6 caratteri) ed eventuale flag <b>Delegato</b> → “Crea accesso”. Per resettare la password, riapri e inserisci una nuova password.</P>
        <Callout tipo="warn">Le sezioni Cruscotto, Stipendi, TFR, Giornaliere e gli elenchi completi sono riservate ad Admin/Delegati: un dipendente riceve “accesso negato”.</Callout>
      </Scheda>

      <Scheda id="area" n="3" titolo="Area del dipendente" accent={A}>
        <P>Il dipendente, entrando nel modulo, vede <b>“La mia area”</b> con: i propri dati, <b>I miei documenti</b> (carica/scarica), <b>Le mie buste paga</b> (sola lettura), <b>Le mie richieste</b> e <b>Le mie note spese</b>.</P>
        <P><b>Fascicolo documenti:</b> il dipendente carica i propri documenti (documento d'identità, IBAN, certificati…). L'ufficio carica i documenti “d'ufficio” (buste paga, contratto, CU…). Il dipendente può eliminare solo i propri caricamenti.</P>
      </Scheda>

      <Scheda id="assenze" n="4" titolo="Richieste assenze" accent={A}>
        <P>Tipi: <b>Ferie, Permesso/ROL, Malattia, Infortunio, Legge 104, Lutto, Congedo, Smartworking, Trasferta, Altro</b>.</P>
        <Steps items={[
          "Il dipendente crea la richiesta (date, eventuali ore, motivo e allegato opzionale, es. certificato).",
          "La richiesta è 'In attesa'; il dipendente può annullarla finché non è decisa.",
          "Admin/Delegato la Approva o Respinge (con motivazione) dalla tab 'Assenze'.",
        ]} />
        <P>Un <b>riepilogo</b> mostra i giorni/ore approvati nell'anno per tipologia.</P>
      </Scheda>

      <Scheda id="note" n="5" titolo="Note spese e rimborsi" accent={A}>
        <P>Categorie: viaggio auto, <b>Km (importo a mano)</b>, pedaggi/parcheggi, treno, aereo/volo, taxi, hotel, pasti, ristoranti, rappresentanza, gadget, varie.</P>
        <Steps items={[
          "Crea la nota spese (titolo, destinazione, periodo).",
          "Aggiungi le voci: categoria, data, descrizione, importo ed eventuale scontrino allegato. I totali (per categoria e generale) si calcolano da soli.",
          "Premi 'Invia per approvazione'.",
          "Admin/Delegato approva/respinge; su una nota approvata usa 'Segna rimborsato'.",
          "Esporta la nota in PDF o Excel.",
        ]} />
      </Scheda>

      <Scheda id="cruscotto" n="6" titolo="Cruscotto HR" accent={A}>
        <P>Tab iniziale per Admin/Delegati: mostra <b>cosa c'è da approvare</b> (assenze + note spese), le <b>note da rimborsare</b> (numero e importo), la <b>spesa dell'anno</b>, le <b>assenze del mese</b>, e i grafici <b>spesa per categoria/persona</b> e <b>assenze per tipo</b>.</P>
      </Scheda>

      <Scheda id="faq" n="7" titolo="FAQ e avvertenze" accent={A}>
        <FAQ items={[
          { q: "Un dipendente non vede la sua area.", a: "Il suo account non è collegato a una scheda persona: crea/ricollega l'accesso dalla tab Soci/Collaboratori (icona 🔑)." },
          { q: "Chi può approvare?", a: "Admin e le persone con il flag 'Delegato'. Puoi delegare/revocare in qualsiasi momento." },
          { q: "Le email di notifica arrivano?", a: "Il flusso è pronto ma le notifiche email HR sono disattivate finché non viene collegata una casella email dell'agenzia." },
          { q: "Posso creare una richiesta/nota per conto di un dipendente?", a: "Sì: come Admin/Delegato, nel dialog di creazione seleziona la persona." },
        ]} />
      </Scheda>
    </ManualeLayout>
  );
}
